import React from 'react';
import { useSelector } from 'react-redux';
import { useUpdateShape } from 'hooks';
import SceneHelper from 'utils/SceneHelper';
import c from './CalendarGrid.module.scss';
import GeneralSettingsSection from './sections/GeneralSettingsSection';
import WeekdayNamesSection from './sections/WeekdayNamesSection';
import GridSpacingSection from './sections/GridSpacingSection';
import DateNumbersSection from './sections/DateNumbersSection';
import DayBordersSection from './sections/DayBordersSection';
import EventTextSection from './sections/EventTextSection';

/**
 * @param {Object} props
 * @param {boolean} [props.desktop]
 * @param {boolean} [props.showTitleOnDesktop]
 * @param {string} [props.title]
 * @returns {React.ReactElement|null}
 */
const CalendarGrid = ({ desktop, showTitleOnDesktop, title }) => {
  const calendar = useSelector(
    /** @param {import('actions/scene.types').StoreState} storeState */ (storeState) =>
      SceneHelper.getCurrentPageShapes(storeState).find((shape) => SceneHelper.isCalendar(shape)),
  );
  const onChange = useUpdateShape(calendar?.id);

  if (!calendar) return null;

  return (
    <div className={c.container}>
      {desktop && showTitleOnDesktop ? <h2 className={c.title}>{title}</h2> : null}
      <GeneralSettingsSection calendar={calendar} onChange={onChange} />
      <WeekdayNamesSection calendar={calendar} onChange={onChange} />
      <GridSpacingSection calendar={calendar} onChange={onChange} />
      <DateNumbersSection calendar={calendar} onChange={onChange} />
      <DayBordersSection calendar={calendar} onChange={onChange} />
      <EventTextSection calendar={calendar} onChange={onChange} />
    </div>
  );
};

export default CalendarGrid;
